var React = require('react');

function ShoppingCartInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Shopping Cart"),React.createElement("path",{"id":"shopping_cart","data-name":"Union 1","d":"M11.068,29.024A3.422,3.422,0,0,1,14.491,25.6a3.7,3.7,0,0,1,.9.121H27.111a3.7,3.7,0,0,1,.9-.121,3.422,3.422,0,1,1-3.422,3.422,3.294,3.294,0,0,1,.15-1h-6.98a3.266,3.266,0,0,1,.149,1,3.422,3.422,0,0,1-6.845,0Zm15.825,0A1.122,1.122,0,1,0,28.015,27.9,1.122,1.122,0,0,0,26.893,29.025Zm-13.524,0A1.122,1.122,0,1,0,14.491,27.9,1.122,1.122,0,0,0,13.369,29.025ZM9.8,22.586,7.151,9.282,5.53,2.3H0V0H7.355L9.187,7.9H35.636l-2.92,14.691Zm1.885-2.292,19.141,0,2.006-10.1H9.676Z","key":1})]);
}

ShoppingCartInline.defaultProps = {"width":"35.636","height":"32.446","viewBox":"0 0 35.636 32.446"};

module.exports = ShoppingCartInline;

ShoppingCartInline.default = ShoppingCartInline;
